import { BrowserModule } from '@angular/platform-browser';
import { NgModule, InjectionToken } from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import { AppRoutingModule} from './app.routing.module';

import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { RequestService } from './services/request.service';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { GlobalsTxt } from './txtGlobals';


//COMPONENTES 

/* import { HomeComponent } from './components/home/home.component';
import { RecuperarPassComponent } from './components/recuperar-pass/recuperar-pass.component';
import { ChangePassComponent} from './components/change-pass/change-pass.component'; */
//Librerias
import { ReactiveFormsModule } from '@angular/forms';

//Servicios
import { ActivatedRouteSnapshot } from '@angular/router';

const externalUrlProvider = new InjectionToken('externalUrlRedirectResolver');

@NgModule({
  declarations: [
    AppComponent,
  
    /* HomeComponent,
    RecuperarPassComponent,
    ChangePassComponent */
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,

  ],
  providers: [RequestService,
    GlobalsTxt,
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
